import Axios from 'axios'
import { api } from '../../../../../../../services/api'
import { format } from 'date-fns'

export const agendamentoRetornoService = {
  async agendarRetorno(agendamento) {
    // const response = await api.post('/site/v2/orcamento-crm/inserir-agendamento-proposta', agendamento)
    const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/orcamento-crm/inserir-agendamento-proposta', agendamento)

    return response.data
  },

  async getAgendamentos({ numeroNota, codigoParceiro, codigoContato, numeroPedido }) {
    const response = await api.get('/site/v2/orcamento-crm/lista-mensagens-agendadas', {
      params: {
        numero_nota: numeroNota,
        codigo_parceiro: codigoParceiro,
        codigo_contato: codigoContato,
        numero_pedido: numeroPedido,
      },
    })

    const mensagensAgendadas = response.data.mensagens_agendadas.map((item) => ({
      ...item,
      data_agendamento: item?.data_agendamento ? format(new Date(item.data_agendamento), "dd/MM/yyyy 'às' HH:mm") : '',
      data_contato: item?.data_contato ? format(new Date(item.data_contato), "dd/MM/yyyy 'às' HH:mm") : '',
    }))

    return mensagensAgendadas
  },

  async excluirAgendamento(id) {
    const response = await api.delete('/site/v2/orcamento-crm/deletar-mensagem-agendada', {
      params: {
        id_mensagem: id,
      },
    })

    return response.data
  },

  async getMensagensSistema({ id_categoria }) {
    const response = await api.get('/site/v2/orcamento-crm/lista-mensagens-sistema', {
      params: {
        id_categoria,
      },
    })

    return response.data
  },

  async getCategoriesSistema() {
    const response = await api.get('/site/v2/orcamento-crm/listagem-categorias-mensagens')

    return response.data
  },

  async getEmailCategories() {
    const response = await api.get('/site/v2/orcamento-crm/listar-categoria-email')

    return response.data
  },

  async getEmailSubjects({ id_categoria_email }) {
    const response = await api.get('/site/v2/orcamento-crm/lista-assuntos-email', {
      params: {
        id_categoria: id_categoria_email,
      },
    })

    return response.data
  },

  async getEmailMensagens({ id_categoria, numero_pedido }) {
    const response = await api.get('/site/v2/orcamento-crm/lista-mensagens-sistema-email', {
      params: {
        id_categoria,
        numero_pedido,
      },
    })

    return response.data
  },
}
